import React from 'react';
import {
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';
import {
    Info as InfoIcon,
    TrendingUp as TrendingUpIcon,
    Settings as SettingsIcon
} from '@mui/icons-material';

const ContextMenu = ({ 
    anchorEl, 
    open, 
    onClose, 
    onSymbolInfo,
    symbolName 
}) => {
    const handleSymbolInfo = () => {
        onSymbolInfo(symbolName, anchorEl);
        onClose();
    };

    if (!open) {
        return null;
    }
    
    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            PaperProps={{
                sx: {
                    backgroundColor: '#2d3748',
                    color: 'white',
                    border: '1px solid #4a5568',
                    borderRadius: '4px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.4)',
                    minWidth: 120,
                    maxWidth: 140,
                    position: 'relative',
                    zIndex: 9999,
                    padding: '2px 0',
                    '& .MuiMenuItem-root': {
                        color: 'white',
                        fontSize: '12px',
                        padding: '4px 8px',
                        minHeight: '24px',
                        margin: '0 2px',
                        borderRadius: '2px',
                        '&:hover': {
                            backgroundColor: '#4a5568',
                            color: '#ffffff',
                        },
                        '&:focus': {
                            backgroundColor: '#4a5568',
                            color: '#ffffff',
                        },
                        '& .MuiListItemIcon-root': {
                            minWidth: '20px',
                            marginRight: '6px',
                        }
                    }
                }
            }}
            disableScrollLock={true}
            disablePortal={false}
            transitionDuration={150}
        >
            <MenuItem onClick={handleSymbolInfo}>
                <ListItemIcon>
                    <InfoIcon sx={{ color: '#06b6d4', fontSize: 14 }} />
                </ListItemIcon>
                <ListItemText 
                    primary="Symbol Info"
                    primaryTypographyProps={{
                        fontSize: '12px',
                        fontWeight: 400,
                        color: 'white'
                    }}
                />
            </MenuItem>
            
            {/* Future menu items can be added here */}
            {/* 
            <MenuItem onClick={handleChart}>
                <ListItemIcon>
                    <TrendingUpIcon sx={{ color: '#06b6d4', fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        View Chart
                    </Typography>
                </ListItemText>
            </MenuItem>
            
            <MenuItem onClick={handleSettings}>
                <ListItemIcon>
                    <SettingsIcon sx={{ color: '#06b6d4', fontSize: 20 }} />
                </ListItemIcon>
                <ListItemText>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        Symbol Settings
                    </Typography>
                </ListItemText>
            </MenuItem>
            */}
        </Menu>
    );
};

export default ContextMenu;
